import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const boxStyle = {
  padding: 12, borderRadius: 8, border: '2px solid #2563eb',
  background: 'var(--card)', minWidth: 220, fontSize: 13, color: 'var(--text)',
};
const selStyle = {
  width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)',
  color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4,
};

export default function StructureNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  const event = data.event || 'bos';
  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#60a5fa' }}>🏗 Market Structure</div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select value={event} onChange={(e) => onChange('event', e.target.value)} style={selStyle}>
        <option value="bos">Break of Structure (BOS)</option>
        <option value="choch">Change of Character (CHoCH)</option>
      </select>

      <select value={data.direction || 'bullish'} onChange={(e) => onChange('direction', e.target.value)} style={selStyle}>
        <option value="bullish">Bullish (upside break)</option>
        <option value="bearish">Bearish (downside break)</option>
      </select>

      <div style={{ marginTop: 2, fontSize: 10, color: 'var(--muted)' }}>
        {event === 'choch'
          ? 'Fires (1) when price breaks structure AGAINST the prior swing sequence.'
          : 'Fires (1) when close breaks beyond the last swing in this direction.'} Compare with value 1.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#2563eb' }} />
    </div>
  );
}
